import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { ARTICLES } from "../constants/blogData";
import Reveal from "../components/Reveal";
import { useSeo } from "../hooks/useSeo";

const LOCALES = { en: "en-GB", fr: "fr-FR", nl: "nl-NL", ar: "ar" };

export default function BlogPage() {
  const { t, lang } = useLanguage();
  const locale = LOCALES[lang] || "en-GB";
  const lp = lang === "en" ? "" : `/${lang}`;
  useSeo(
    "Journal — Antwerp Chauffeur Notes | MIRAL GROUP",
    "Short reads on premium electric mobility in Antwerp: airport protocol, EU Quarter transport and round-the-clock concierge service."
  );

  return (
    <main data-testid="blog-page" className="pt-[72px] min-h-screen">
      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
          <Reveal>
            <p className="eyebrow">{t.blog.eyebrow}</p>
            <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight">
              {t.blog.title}
            </h1>
            <p className="mt-6 max-w-[60ch] text-lg text-slate-300">{t.blog.sub}</p>
          </Reveal>

          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {ARTICLES.map((a, i) => {
              const c = a.t[lang] || a.t.en;
              return (
                <Reveal key={a.slug} delay={i * 0.08}>
                  <Link
                    to={`${lp}/blog/${a.slug}`}
                    data-testid={`blog-card-${a.slug}`}
                    className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0F1015] transition-colors duration-500 hover:border-gold/40"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={a.image}
                        alt={c.title}
                        className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.06]"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1015] via-transparent to-transparent" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <p className="font-mono2 text-[10px] uppercase text-slate-500">
                        {new Date(a.date).toLocaleDateString(locale, { dateStyle: "long" })} · {a.minutes} {t.blog.minRead}
                      </p>
                      <h2 className="mt-3 font-display text-lg font-bold text-white group-hover:text-gold-pale transition-colors duration-300">
                        {c.title}
                      </h2>
                      <p className="mt-2 text-sm text-slate-400 leading-relaxed">{c.excerpt}</p>
                      <span className="mt-auto pt-5 inline-flex items-center gap-2 font-mono2 text-[11px] uppercase text-gold-soft">
                        {t.blog.readMore} <ArrowRight size={13} />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
